import { ROUTES } from "@/shared/model/routes";

import type { Tab, SearchResult } from "./types";

export { type SearchResult } from "./types";

export function getSearchType(tab: Tab): "products" | "sellers" | null {
  switch (tab) {
    case "catalog":
      return "products";
    case "sellers":
      return "sellers";
    case "all":
    default:
      return null;
  }
}

export function getResultRoute(result: SearchResult): { path: string } {
  if (result.type === "product" && result.product_type) {
    return {
      path: ROUTES.PRODUCT.replace(":id", result.id.toString()).replace(
        ":product_type",
        result.product_type.toString(),
      ),
    };
  }
  if (result.type === "seller") {
    return {
      path: ROUTES.STORE.replace(":id", result.id.toString()),
    };
  }
  return { path: "/" };
}
